/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum PlaybackSpeed {
    SPEED_REWIND_3 = -60,
    SPEED_REWIND_2 = -18,
    SPEED_REWIND_1 = -3,
    SPEED_FASTFORWARD_1 = 3,
    SPEED_FASTFORWARD_2 = 18,
    SPEED_FASTFORWARD_3 = 60,
}
